import { render, staticRenderFns } from "./SvgChangelog.vue?vue&type=template&id=3691c6ba&"
import script from "./SvgChangelog.vue?vue&type=script&lang=js&"
export * from "./SvgChangelog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports